export default "__VITE_ASSET__DmMdkABN__"